<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="sink"> </p>
<blockquote>
<p class="center "><em>To my two favorite Julies:</em></p>
<p class="center "><em>Julie Shiroishi</em></p>
<p class="center "><em>and</em></p>
<p class="center "><em>Julie Ulmer</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?8fb0cc4c